/**
 * PriceQuote — Narx aytildi (kutilayotgan sotuv) sxemalari.
 *
 * Mijoz zapchast so'radi, narx aytildi, "pulimni olib kelaman" dedi —
 * potensial sotuv kuzatib boriladi. Holat: WAITING → RETURNED → SOLD (yoki LOST).
 */
import { z } from 'zod';
export const QUOTE_STATUSES = [
    'WAITING', // kutilmoqda (pul olib kelaman dedi)
    'RETURNED', // qaytib keldi
    'SOLD', // sotildi
    'LOST', // kelmadi / boshqa joydan oldi
];
const currencyEnum = z.enum(['UZS', 'USD', 'RUB', 'CNY']);
export const createPriceQuoteSchema = z.object({
    customerName: z.string().trim().min(1, 'Mijoz ismi kerak').max(150),
    customerPhone: z.string().trim().max(30).nullable().optional(),
    productName: z.string().trim().min(1, 'Mahsulot nomi kerak').max(300),
    quotedPrice: z.number().min(0, 'Narx manfiy bo\'lmaydi').max(1_000_000_000),
    currency: currencyEnum.default('UZS'),
    note: z.string().trim().max(500).nullable().optional(),
});
export const updatePriceQuoteStatusSchema = z.object({
    status: z.enum(QUOTE_STATUSES),
});
export const priceQuoteQuerySchema = z.object({
    status: z.enum(QUOTE_STATUSES).optional(),
});
//# sourceMappingURL=price-quote.schema.js.map